import { observable } from "mobx";
import { StatusFlag, FeatureLevel, FeatureFilter } from "./enums";
import { copy } from "../utils/data";

export default class FeaturedContent {
  @observable status: StatusFlag;
  @observable level: FeatureLevel;
  @observable order: number;
  @observable imageId: string;
  @observable mobileImageId: string;
  @observable tabletImageId: string;
  @observable link: string;
  @observable external: boolean;
  @observable filter: FeatureFilter;

  constructor(fc: FeaturedContent) {
    copy(fc, this);
  }
}


// WEBPACK FOOTER //
// ./src/models/featuredContent.ts